import React from 'react';

function FrontPage() {
    return (
        <div>
            <h1>Welcome to the Front Page</h1>
            <p>This is the content of the front page.</p>
        </div>
    );
}

export default FrontPage;
